module.exports = __webpack_public_path__ + "static/media/call-feedback-dishonest-contributor-color.585733d4.svg";